
import React from "react";
import { useMutation } from "react-query";
import { deleteOfficeStatus } from "../../../../../actions/Utilities/OfficeStatus";
import { toast } from "../../../../../components/toastNotification";
import { useRecoilState, useSetRecoilState } from "recoil";
import { editStateOfficeStatus, officeStatusReFetching } from "../atoms/atoms";

export default function useDisableOfficeStatus() {
  const setActionEditState = useSetRecoilState(editStateOfficeStatus);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeStatusReFetching
  );
  
  const { mutate } = useMutation((ids: number[]) => deleteOfficeStatus(ids), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Disabling Office Status failed", res.Message, "error");
      } else {
      switch (true) {
        case res == "Success":
          toast.fire(
            "Success",
            "Office Status Disabled Successfully",
            "success"
          );
          break;
        case res.includes("Notification insert Failed!"):
          toast.fire(
            "Success ",
            `Office Status Disabled Successfully, BUT ${res}`,
            "warning"
          );
          break;
        case res.includes("Operation Failed!"):
            toast.fire(
                "Disabling Office Status failed ",
                `Server Error: ${res}`,
                "error"
            );
            break;
        case res.includes("Status not found"):
          toast.fire(
            "Disabling Office Status failed ",
            `Error: ${res}`,
            "error"
          );
          break;
        default:
          toast.fire("Disabling Office Status failed", res.Message, "error");
      }
    }
      // Redirect to View
      setActionEditState(false);
      
      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error) => {
      toast.fire("Disabling Office Status failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
}

